import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { isWhiteLabelEnabled } from '../../utils/config';

const RegistrationSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const triggerLogin = sessionStorage.getItem("triggerLogin");

    const timer = setTimeout(() => {
      if (triggerLogin === "true") {
        window.location.href = "/"; 
      } else {
        navigate("/"); 
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const isWhiteLabel = isWhiteLabelEnabled();

  return (
    <div className="success-container">
      <div className="success-card">
        <h2 className="success-title">
          {t("register_success.registration_successful")}
        </h2>
  
        <p className="success-message">
          {isWhiteLabel
            ? t("register_success.account_created_whitelabel")
            : t("register_success.account_created_non_whitelabel")}
        </p>
  
        {/* <p className="success-redirect">
          {t("register_success.redirect_message")}
        </p> */}
      </div>
    </div>
  );

};

export default RegistrationSuccess;
